import React from 'react'
import clsx from 'clsx'
import iconsSet from './config'
import * as PropTypes from 'prop-types'

const CreatePaymentLogoIcon = ({
  iconsSet,
  name,
  className,
  type = 'component',
  color = 'basic-primary-white',
  width = null,
  height = null,
}) => {
  const Component = !iconsSet[name]
    ? iconsSet['getuniq'][type]
    : iconsSet[name][type]

  const colorsStaticSuffix = '-static'
  const sizeProps = width
    ? {
        width: width,
        height: height ?? width,
      }
    : {}

  return (
    <Component
      className={clsx('payment-logo', className, ['' + type], {
        [`color${colorsStaticSuffix}-${color}`]: color,
      })}
      {...sizeProps}
    />
  )
}

CreatePaymentLogoIcon.propTypes = {
  iconsSet: PropTypes.object,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(['component', 'inner']),
}

const PaymentLogo = (args) => CreatePaymentLogoIcon({ ...args, iconsSet })

export default PaymentLogo
